import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ArtworkReconvertController extends Controller {
  static targets = [
    'thresholdSlider', 'thresholdValue',
    'brightnessSlider', 'brightnessValue',
    'contrastSlider', 'contrastValue',
    'ditheringOption',
    'submitBtn', 'resetBtn', 'form'
  ]

  static values = {
    defaultThreshold: { type: Number, default: 50 },
    defaultBrightness: { type: Number, default: 0 },
    defaultContrast:   { type: Number, default: 0 },
    defaultDithering:  { type: Number, default: 0 }
  }

  connect () {
    this.updateThreshold()
    this.updateBrightness()
    this.updateContrast()

    this.formTarget.addEventListener('turbo:submit-start', this._onSubmitStart = () => this.#setLoading(true))
    this.formTarget.addEventListener('turbo:submit-end',   this._onSubmitEnd   = () => this.#setLoading(false))
  }

  disconnect () {
    this.formTarget.removeEventListener('turbo:submit-start', this._onSubmitStart)
    this.formTarget.removeEventListener('turbo:submit-end',   this._onSubmitEnd)
  }

  updateThreshold () {
    const slider = this.thresholdSliderTarget
    const value = parseInt(slider.value, 10)
    this.thresholdValueTarget.textContent = `${value}%`
    this.#updateFill(slider)
  }

  updateBrightness () {
    const slider = this.brightnessSliderTarget
    const value = parseInt(slider.value, 10)
    this.brightnessValueTarget.textContent = this.#formatSigned(value)
    this.#updateFill(slider)
  }

  updateContrast () {
    const slider = this.contrastSliderTarget
    const value = parseInt(slider.value, 10)
    this.contrastValueTarget.textContent = this.#formatSigned(value)
    this.#updateFill(slider)
  }

  selectDithering (event) {
    const selected = parseInt(event.target.value, 10)
    this.ditheringOptionTargets.forEach(label => {
      const isActive = parseInt(label.dataset.value, 10) === selected
      this.#setDitherActive(label, isActive)
    })
  }

  reset () {
    this.thresholdSliderTarget.value  = this.defaultThresholdValue
    this.brightnessSliderTarget.value = this.defaultBrightnessValue
    this.contrastSliderTarget.value   = this.defaultContrastValue
    this.updateThreshold()
    this.updateBrightness()
    this.updateContrast()

    this.ditheringOptionTargets.forEach(label => {
      const isDefault = parseInt(label.dataset.value, 10) === this.defaultDitheringValue
      this.#setDitherActive(label, isDefault)
    })

    this.#setLoading(true)
    this.formTarget.requestSubmit()
  }

  #setLoading (loading) {
    this.submitBtnTarget.disabled = loading
    this.resetBtnTarget.disabled  = loading
  }

  #updateFill (slider) {
    const min = parseFloat(slider.min) || 0
    const max = parseFloat(slider.max) || 100
    const val = parseFloat(slider.value)
    const pct = ((val - min) / (max - min)) * 100
    slider.style.setProperty('--slider-fill', `${pct}%`)
  }

  #setDitherActive (label, isActive) {
    const radio = label.querySelector('input[type=radio]')
    if (radio) radio.checked = isActive
  }

  #formatSigned (value) {
    if (value === 0) return 'Neutral'
    return value > 0 ? `+${value}` : `${value}`
  }
}

stimulus.register('artwork-reconvert', ArtworkReconvertController)
